import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Spinner from 'components/Spinner'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import API from 'state/API'
import { getLoading } from 'state/Request'
import { klass } from 'utils'

EmptyMessage.propTypes = {
	icon      : Spinner.propTypes.icon.isRequired,
	resource  : API.PROPTYPE_RESOURCES.isRequired,
	msg       : PropTypes.node,
	defaultMsg: PropTypes.string,
}

/**
 * @param icon
 * @param resource {string|string[]}
 * @param sm
 * @param noLoading
 * @param msg
 * @param defaultMsg
 * @returns {JSX.Element}
 * @constructor
 */
export default function EmptyMessage({ icon, resource, sm = false, noLoading = false, msg = '', defaultMsg = '' }) {
	icon          = Spinner.simpleIcon(icon)
	const loading = useSelector(getLoading(resource))

	if (!msg && !defaultMsg) {
		console.error('<EmptyMessage> requires either `msg`, `defaultMsg`, or both, but none was given.')
	}

	return <div {...klass('empty-area', { sm, noLoading })}>
		{!noLoading && loading?
			<Spinner icon={icon}/>
			:
			<>
				<FontAwesomeIcon {...icon} size="4x" className="mt-2"/>
				{(msg || defaultMsg) && <p className="my-3">
					{defaultMsg}
					{defaultMsg && msg? <br/> : null}
					{msg}
				</p>}
			</>
		}
	</div>
}
